import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles, MessageSquare, FolderOpen, Users, UserCog, X, ArrowRight } from 'lucide-react';

const ITEMS = [
  { icon: MessageSquare, title: 'Ask the AI anything', desc: 'Question 50 years of IPMI research and get answers with cited sources.' },
  { icon: FolderOpen, title: 'Browse the library', desc: 'Filter and search every paper, presentation, and newsletter.' },
  { icon: Users, title: 'Find the right people', desc: 'Search the member directory by name, company, or area of expertise.' },
  { icon: UserCog, title: 'Make it yours', desc: 'Use the avatar menu (top-right) to edit your profile and privacy settings.' },
];

const MemberWelcomeModal = ({ show, memberName, onClose }) => {
  const first = (memberName || '').trim().split(' ')[0];
  return (
    <AnimatePresence>
      {show && (
        <motion.div className="kb-disclaimer-overlay" onClick={onClose}
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          data-testid="kb-member-welcome-overlay">
          <motion.div className="kb-disclaimer-modal kb-guide-modal" onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, scale: 0.96, y: 12 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: 0.96 }}
            data-testid="kb-member-welcome-modal">
            <div className="kb-disclaimer-header">
              <Sparkles size={18} />
              <h3>{first ? `Welcome, ${first}!` : 'Welcome to the IPMI Library!'}</h3>
              <button className="kb-disclaimer-close" onClick={onClose} data-testid="kb-member-welcome-close">
                <X size={18} />
              </button>
            </div>
            <div className="kb-disclaimer-body kb-guide-body">
              <p style={{ marginTop: 0, fontSize: 14, color: 'var(--kb-fg-soft, #6B7280)' }}>
                Here are a few things you can do — explore at your own pace.
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 14, margin: '18px 0 8px' }}>
                {ITEMS.map((it, i) => (
                  <div key={i} data-testid={`kb-welcome-item-${i}`}
                    style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
                    <span style={{
                      flexShrink: 0, width: 38, height: 38, borderRadius: 10,
                      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                      background: 'rgba(37,99,235,0.10)', color: '#2563EB',
                    }}>
                      <it.icon size={18} />
                    </span>
                    <div>
                      <strong style={{ display: 'block', fontSize: 14.5, marginBottom: 2 }}>{it.title}</strong>
                      <p style={{ margin: 0, fontSize: 13, lineHeight: 1.5, color: 'var(--kb-fg-soft, #6B7280)' }}>{it.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
              <p style={{
                margin: '16px 0 0', fontSize: 12.5, lineHeight: 1.5,
                color: 'var(--kb-fg-soft, #8B96A5)',
                background: 'rgba(245,158,11,0.07)', border: '1px solid rgba(245,158,11,0.22)',
                borderRadius: 8, padding: '10px 12px',
              }}>
                This is an early preview. If you spot anything off, use <strong>“Report a problem”</strong> on
                the chat screen — your feedback shapes what we launch.
              </p>
              <button
                onClick={onClose}
                data-testid="kb-member-welcome-cta"
                style={{
                  marginTop: 18, width: '100%',
                  display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                  background: '#2563EB', color: '#fff', border: 'none',
                  padding: '12px 18px', borderRadius: 9, fontSize: 14.5, fontWeight: 600,
                  cursor: 'pointer',
                }}>
                Start exploring <ArrowRight size={16} />
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MemberWelcomeModal;
